module.exports = __webpack_public_path__ + "img/ygy.2cb6b892.png";